import { render, staticRenderFns } from "./DepartmentTable.vue?vue&type=template&id=4637ab4f&"
import script from "./DepartmentTable.vue?vue&type=script&lang=ts&"
export * from "./DepartmentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports